var exports = {
  "kL": "container__qcj0r_",
  "rf": "body__fphukB",
  "eu": "editMetadata__ws0CPo",
  "r9": "editButton__kkP1ND",
  "Br": "reactions__SrdnFb",
  "lM": "editHistoryLoading__OUcXhA",
  "bi": "editHistoryLabel__ISZtbO",
};

module.exports = exports;
